import Big from 'big.js';
import _findKey from 'lodash/findKey';
import { Parcel, ShipmentType } from '../../types/common';
import { ENVELOPE_WEIGHT, PresetId, presetSizes } from '../../common/package';

export const getPresets = (type: ShipmentType): Record<string, Parcel> => {
  return presetSizes[type];
};

export const getMatchedPresetSize = (pkg: Parcel, type: ShipmentType): string | undefined => {
  const { length, width, height, weight } = pkg || {};
  const preset = presetSizes[type];
  return _findKey(preset, { length, width, height, weight });
};

export const getPresetSize = (id: PresetId, type: ShipmentType): Parcel => {
  const preset = presetSizes[type];
  return preset[id];
};

const getActualWeight = (pkg: Parcel): number => {
  return pkg.weight;
};

const getVolumetricWeight = (pkg: Parcel): number => {
  const volumes = pkg.width * pkg.length * pkg.height;
  return Math.round((volumes / 5000) * 10) / 10;
};

export const getParcelsActualWeight = (parcels: Parcel[]): number =>
  parcels
    .reduce((acc, parcel) => {
      return acc.plus(getActualWeight(parcel));
    }, new Big(0))
    .toNumber();

export const getParcelsVolumetricWeight = (parcels: Parcel[]): number =>
  parcels.reduce((acc, parcel) => {
    return acc + getVolumetricWeight(parcel);
  }, 0);

export const getDisplayWeight = (pkg: Parcel, type: ShipmentType): number => {
  // Display max. weight with envelope buffer to users
  if (type === ShipmentType.DOCUMENT) return pkg.weight - ENVELOPE_WEIGHT;
  return pkg.weight;
};
